import asyncActionTypes from './types.js';
import { getCountriesCMS } from '../../cms-wrapper/cms';
import errorTrackingFromCMS from '../../scripts/analytics/creators/error';
import { sendAnalytics } from '../../scripts/analytics/tracker';

export function retrieveCountriesFromCMS( language ) {
  return function action( dispatch ) {
    const opts = { 'language': language, 'status': '1' };
    dispatch( _getCountriesCmsStart() ); // inicia
    const request = getCountriesCMS(opts); // Busca datos desde el CMS
    request.then( response => {
      if (response.error) {
        const statusCode = response.error.response && response.error.response.status ? response.error.response.status : 503;
        const urlErrorEndpoint = response.error.request && response.error.request.responseURL ? response.error.request.responseURL : null;
        dispatch( _getCountriesCmsFail(response.error) );
        dispatch(sendAnalytics({
          eventCreator: errorTrackingFromCMS.errorFromCMS({
            'type': 'Fatal',
            'statusCode': statusCode,
            'code': '13110921',
            'actionable': 'ABORT',
            'actionType': 'RETRIEVE_CMS_COUNTRIES',
            'errorMsg': response.error.message ? `${response.error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
            'errorExtraInfo': response.error.stack ? response.error.stack : 'Service Unavailable from CMS, please try again some minutes later',
          }),
        }));
      } else {
        dispatch( _getCountriesCms(response) );
      }
    }).catch( error => {
      const urlErrorEndpoint = error.request && error.request.responseURL ? error.request.responseURL : null;
      dispatch( _getCountriesCmsFail(error) );
      dispatch(sendAnalytics({
        eventCreator: errorTrackingFromCMS.errorFromCMS({
          'type': 'Fatal',
          'statusCode': 503,
          'code': '13110921',
          'actionable': 'ABORT',
          'actionType': 'RETRIEVE_CMS_COUNTRIES',
          'errorMsg': error.message ? `${error.message} ${urlErrorEndpoint}` : `CMS_SERVICE_UNAVAILABLE ${urlErrorEndpoint}`,
          'errorExtraInfo': error.stack ? error.stack : 'Service Unavailable from CMS, please try again some minutes later',
        }),
      }));
    });
  };
}

export const _getCountriesCmsStart = () => ({
  type: asyncActionTypes.RETRIEVE_CMS_COUNTRIES.START,
});

export const _getCountriesCms = ( response ) => ({
  type: asyncActionTypes.RETRIEVE_CMS_COUNTRIES.SUCCESS,
  payload: response,
});

export const _getCountriesCmsFail = ( error ) => ({
  type: asyncActionTypes.RETRIEVE_CMS_COUNTRIES.FAIL,
  error: error,
});
